import wamoLogoLoading from 'assets/lotties/wamo-logo-loading.json';

const LOTTIES = {
  wamoLogoLoading,
};

export default LOTTIES;
